import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const TopNav = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  const links = [
    { path: '/', label: 'Projects' },
    { path: '/reels', label: 'Reels' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  const socials = [
    { href: 'https://www.instagram.com/studio_varadanvekar/?hl=en', label: 'Instagram', icon: <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg> },
    { href: 'https://www.linkedin.com/in/studiovaradanvekar', label: 'LinkedIn', icon: <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg> },
    { href: 'https://www.behance.net/chaitananvekar?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnCZrMhW7e31nfmTA2o-RQ-SybRuEIY3V0ossSOSI2fsD8hyvZRGmCxUZyS6g_aem_m6ZTAwadM2aN0jooneAJ5g', label: 'Behance', icon: <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.338.5-.837.9-1.502 1.22.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.67.767-.63.165-1.27.25-1.94.25H0V4.51h6.938v-.007zM6.545 10.16c.6 0 1.09-.15 1.47-.45.38-.3.56-.73.56-1.29 0-.31-.05-.57-.17-.78-.11-.21-.26-.38-.46-.52-.19-.14-.42-.24-.68-.3-.27-.06-.56-.09-.86-.09H3.72v3.44h2.825zm.185 5.63c.32 0 .62-.03.91-.09.29-.06.55-.16.78-.31.22-.15.4-.35.53-.6.13-.26.19-.58.19-.96 0-.75-.22-1.29-.66-1.61-.44-.32-1.01-.48-1.72-.48H3.72v4.05h3.01zM15.44 4.16h5.93v1.56h-5.93V4.16zm7.41 6.83c.21.56.31 1.17.31 1.85h-6.57c.04.9.35 1.59.91 2.08.57.49 1.26.73 2.08.73.58 0 1.08-.14 1.5-.42.42-.28.72-.62.9-1.02h2.77c-.46 1.34-1.17 2.32-2.13 2.93-.96.61-2.12.92-3.48.92-.95 0-1.82-.16-2.6-.49-.78-.33-1.45-.79-2.01-1.39-.55-.6-.98-1.31-1.28-2.13-.3-.82-.46-1.72-.46-2.69 0-.93.15-1.8.46-2.61.31-.82.74-1.53 1.3-2.12.56-.6 1.22-1.06 2-1.39.77-.33 1.62-.5 2.55-.5.99 0 1.87.19 2.63.58.76.39 1.4.92 1.91 1.59.51.67.88 1.44 1.11 2.31zm-2.6.59c-.09-.78-.38-1.41-.86-1.89-.48-.48-1.12-.72-1.92-.72-.52 0-.97.1-1.35.29-.38.19-.69.44-.94.74-.25.31-.44.65-.57 1.02-.13.37-.21.73-.24 1.07h5.88v-.51z"/></svg> },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 bg-white" data-testid="app-header">
      <div className="flex items-center justify-between px-4 md:px-12 py-4 md:py-5">
        {/* Logo + Name */}
        <Link to="/" className="site-name text-lg md:text-2xl font-normal flex items-center gap-2 md:gap-3 min-w-0" data-testid="logo-text">
          <img
            src="https://customer-assets.emergentagent.com/job_varad-founder-hub/artifacts/i4elqnwv_LOGO.png"
            alt="Studio V.A. Logo"
            className="h-8 w-8 md:h-12 md:w-12 object-contain flex-shrink-0"
            style={{ mixBlendMode: 'multiply' }}
            data-testid="logo-image"
          />
          <span className="truncate">Studio Varad Anvekar</span>
        </Link>

        {/* Desktop nav — always inline */}
        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {links.map(({ path, label }) => (
            <Link
              key={path}
              to={path}
              className={`nav-link ${location.pathname === path ? 'active' : ''}`}
              data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}
            >
              {label}
            </Link>
          ))}
          {socials.map(({ href, label, icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link flex items-center"
              data-testid={`nav-${label.toLowerCase()}`}
              title={label}
            >
              {icon}
            </a>
          ))}
        </nav>

        {/* Mobile dropdown trigger */}
        <div className="md:hidden relative flex-shrink-0" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center nav-link p-1"
            data-testid="mobile-dropdown-trigger"
            aria-label="Menu"
          >
            {dropdownOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

          {dropdownOpen && (
            <div
              className="absolute right-0 top-full mt-2 bg-white border border-gray-200 shadow-sm py-2 min-w-[160px] z-50"
              data-testid="mobile-dropdown-menu"
            >
              {links.map(({ path, label }) => (
                <Link
                  key={path}
                  to={path}
                  className={`block px-5 py-2.5 nav-link text-left w-full ${
                    location.pathname === path ? 'active' : ''
                  }`}
                  data-testid={`mobile-nav-${label.toLowerCase().replace(' ', '-')}`}
                >
                  {label}
                </Link>
              ))}
              <div className="border-t border-gray-100 my-1"></div>
              {socials.map(({ href, label, icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 px-5 py-2.5 nav-link w-full"
                  data-testid={`mobile-nav-${label.toLowerCase()}`}
                >
                  {icon}
                  <span>{label}</span>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopNav;
